import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import IcEditBold from 'src/assets/images/icEditBold.svg';
import EditNicknameModal from 'src/components/EditNicknameModal';
import { showModalAtom } from 'src/stores/modal/atoms';
import { ModalType } from 'src/types/Modal';
const Button = styled.button`
  all: unset;
  cursor: pointer;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;
const Icon = styled(IcEditBold)`
  width: 100%;
  height: 100%;
  color: ${({
  theme
}) => theme.color.contentBrightFixed};
`;
const ChangeNicknameButton = () => {
  const showModal = useSetAtom(showModalAtom);
  const handleClick = () => {
    showModal({
      key: ModalType.EDIT_NICKNAME,
      component: EditNicknameModal
    });
  };
  return <Button id='profile-card-change-nickname' onClick={handleClick} data-sentry-element="Button" data-sentry-component="ChangeNicknameButton" data-sentry-source-file="ChangeNicknameButton.tsx">
      <Icon data-sentry-element="Icon" data-sentry-source-file="ChangeNicknameButton.tsx" />
    </Button>;
};
export default ChangeNicknameButton;